import { render, staticRenderFns } from "./StarshipsWeapons.vue?vue&type=template&id=7f641816&lang=pug&"
import script from "./StarshipsWeapons.vue?vue&type=script&lang=ts&"
export * from "./StarshipsWeapons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports